import { initialState } from "./auth.state";
import { createReducer, on } from "@ngrx/store";
import { loginError, loginSuccess, logoutSuccess } from "./auth.actions";
import * as AuthActions from "./auth.actions";

export const authReducer = createReducer(
  initialState,
  on(loginSuccess, (state, action) => ({
    ...state,
    isLoggedIn: true,
    token: action.token,
    error: null
  })),
  on(loginError, (state, action) => ({
    ...state,
    isLoggedIn: false,
    token: null,
    error: action.error
  })),
  on(logoutSuccess, (state, action) => ({
    ...state,
    isLoggedIn: false,
    token: null,
    error: null
  })),
  on(AuthActions.loadUserSuccess, (state, action) => ({
    ...state,
    user: action.user,
    error: null
  })),
  on(AuthActions.updateUserStore, (state, action) => ({
    ...state,
    user: action.user
  }))
)
